import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "form-actions" }
const _hoisted_5 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $props.isOpen,
    title: $setup.modalTitle,
    onClose: _cache[2] || (_cache[2] = $event => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      ($props.mode === 'add' && $props.type && $props.schema[$props.type] && $props.parent && $props.parentMovie)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode($setup["Tabs"], {
              modelValue: $setup.tab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.tab) = $event)),
              tabs: [
          { label: 'Create New', value: 'create' },
          { label: 'Select Existing', value: 'select' }
        ]
            }, null, 8 /* PROPS */, ["modelValue"]),
            ($setup.tab !== 'select')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode($setup["MovieDetailsForm"], {
                    "entity-type": $props.type,
                    values: $setup.formEntity,
                    schema: $props.schema,
                    "submit-text": 'Create',
                    onSubmit: $setup.handleFormSubmit
                  }, null, 8 /* PROPS */, ["entity-type", "values", "schema"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode($setup["FormGroup"], null, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.selectedId) = $event))
                      }, [
                        _cache[3] || (_cache[3] = _createElementVNode("option", { value: "" }, "Select...", -1 /* CACHED */)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.availableEntities, (entity) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: entity.id,
                            value: entity.id
                          }, _toDisplayString($props.schema[$props.type].fields
                  .map((f) => entity[f.name])
                  .filter(Boolean)
                  .join(' | ') || entity.id), 9 /* TEXT, PROPS */, _hoisted_3))
                        }), 128 /* KEYED_FRAGMENT */))
                      ], 512 /* NEED_PATCH */), [
                        [_vModelSelect, $setup.selectedId]
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      disabled: !$setup.selectedId,
                      onClick: $setup.handleAddExisting
                    }, "Use selected " + _toDisplayString($props.type), 9 /* TEXT, PROPS */, _hoisted_5)
                  ])
                ]))
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            ($props.mode)
              ? (_openBlock(), _createBlock($setup["MovieDetailsForm"], {
                  key: 0,
                  "entity-type": $props.type,
                  values: $setup.formEntity,
                  schema: $props.schema,
                  "submit-text": $props.mode === 'edit' ? 'Update' : 'Create',
                  onSubmit: $setup.handleFormSubmit
                }, null, 8 /* PROPS */, ["entity-type", "values", "schema", "submit-text"]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-open", "title"]))
}